import * as React from 'react';
import { useZTFeatures as useZapSharingZtFeatures } from '@zapier/sharing';
import { addTruthyParamsToUrl, extractParams } from '@zapier/url-utils';

const initialValue = {};
const initialData = { isDeveloper: false, accountId: 0 };

const ZtFeaturesContext = React.createContext(initialValue);

export const ZtFeaturesProvider = ({ children }) => {
  const [data, setData] = React.useState(initialData);
  const features = useZapSharingZtFeatures(data);
  // we'll be incrementally rolling out the deprecation
  // of the old ZT Creator process based on a set of
  // gargoyle switches
  const createZapTemplateUrl = features.shouldUseZtFeatures
    ? addTruthyParamsToUrl('/webintent/create-zap', {
        context: data.accountId,
        identity: extractParams(window.location.hash).identity,
      })
    : '/zap-templates/create';
  const value = { ...features, createZapTemplateUrl, setData };
  return (
    <ZtFeaturesContext.Provider value={value}>
      {children}
    </ZtFeaturesContext.Provider>
  );
};

export const useZtFeatures = () => {
  const context = React.useContext(ZtFeaturesContext);
  if (!context) {
    throw new Error(`'useZtFeatures' must be used within a ZtFeaturesProvider`);
  }
  return context;
};
